import { Link } from "react-router-dom";
import { Mail, Clock, LifeBuoy, ArrowRight } from "lucide-react";

const SUPPORT_EMAIL = "support@sellend.com";

export default function Contact() {
  return (
    <div data-testid="contact-page" className="min-h-screen">
      <section className="max-w-3xl mx-auto px-5 sm:px-8 pt-16 pb-8">
        <span className="inline-block text-xs font-bold uppercase tracking-[0.2em] text-[#FF5A00] mb-5">Get in touch</span>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter leading-[0.95]">
          Contact <span className="text-[#FF5A00]">us</span>
        </h1>
        <p className="text-lg text-muted-foreground mt-6 leading-relaxed">
          We're here to help. For support, account assistance, disputes, or general enquiries, please contact the SelLend Support Team.
        </p>
      </section>

      <section className="max-w-3xl mx-auto px-5 sm:px-8 pb-16">
        <div className="grid sm:grid-cols-2 gap-5">
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            data-testid="contact-email-card"
            className="bg-white border border-black/10 rounded-2xl p-7 hover:border-[#FF5A00]/40 transition-colors group"
          >
            <div className="w-11 h-11 rounded-xl bg-[#FFF0E8] flex items-center justify-center mb-4">
              <Mail className="w-5 h-5 text-[#FF5A00]" />
            </div>
            <h3 className="font-semibold text-lg">Email support</h3>
            <p className="text-muted-foreground text-sm mt-1">Reach the SelLend Support Team anytime.</p>
            <span className="inline-flex items-center gap-1 mt-4 font-medium text-[#FF5A00] group-hover:gap-2 transition-all">
              {SUPPORT_EMAIL} <ArrowRight className="w-4 h-4" />
            </span>
          </a>

          <div className="bg-white border border-black/10 rounded-2xl p-7">
            <div className="w-11 h-11 rounded-xl bg-[#E3F0E3] flex items-center justify-center mb-4">
              <Clock className="w-5 h-5 text-[#2E7D32]" />
            </div>
            <h3 className="font-semibold text-lg">Response time</h3>
            <p className="text-muted-foreground text-sm mt-1 leading-relaxed">We aim to respond within 1–2 business days.</p>
          </div>
        </div>

        <div className="bg-[#0A0A0A] text-white rounded-3xl p-8 sm:p-10 mt-5 flex items-start gap-4">
          <div className="w-11 h-11 rounded-xl bg-white/10 flex items-center justify-center shrink-0">
            <LifeBuoy className="w-5 h-5 text-[#FF5A00]" />
          </div>
          <div>
            <h3 className="font-semibold text-lg">Need help with a booking or dispute?</h3>
            <p className="text-white/60 text-sm mt-1 leading-relaxed">
              Many issues can be handled right from your dashboard — report a problem, track a booking, or open a dispute there. For anything else, email us and we'll take care of you.
            </p>
            <div className="flex flex-wrap gap-3 mt-5">
              <a href={`mailto:${SUPPORT_EMAIL}`} data-testid="contact-email-btn" className="bg-[#FF5A00] text-white rounded-full px-5 py-2.5 text-sm font-medium hover:bg-white hover:text-[#0A0A0A] transition-colors">
                Email {SUPPORT_EMAIL}
              </a>
              <Link to="/faq" data-testid="contact-faq-link" className="rounded-full px-5 py-2.5 text-sm font-medium border border-white/20 hover:bg-white/10 transition-colors">
                Read the FAQs
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
